import React, { createContext, useState,useContext, } from 'react';
import { AuthContext } from './AuthContext';

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
    const global_data = {
      //http://52.221.103.151:8087/
      //https://api.cfanapp.com/cfan/
        baseUrl:"http://52.221.103.151:8087/",
        commonEndpoints:"admin/metadata/v1/",
        webEndpoints:"web/user/v1/",
        training_endpoits:"admin/training/v1/",
        timeSlots: 'admin/v1/',

    }
    let default_country_code = 195;
    
    let default_langage_code = 1;
    if(localStorage.getItem('default_country_code') == null){
    localStorage.setItem('default_country_code', default_country_code);
    localStorage.setItem('default_langage_code', default_langage_code);
    }else{
      default_country_code = parseInt(localStorage.getItem('default_country_code'));
      default_langage_code =  parseInt(localStorage.getItem('default_langage_code'));
      console.log(default_country_code);
    }

  const [siteName, setSiteName] = useState(global_data);

  const [default_country,setDefaultCoutry] = useState(default_country_code);
  const [default_langage,setDefaultLangague] = useState(default_langage_code);

   let default_country_detail_data = null;
    let default_language_detail_data =null;
  if(localStorage.getItem('defult_country_details') != null){
    default_country_detail_data = JSON.parse(localStorage.getItem('defult_country_details'));
    default_language_detail_data = JSON.parse(localStorage.getItem('defult_language_details'));
  }

    const [default_country_detail,setDefaultCoutryDetails] = useState(default_country_detail_data);
  const [default_langage_details,setDefaultLangagueDetails] = useState(default_language_detail_data);

 const get_token = localStorage.getItem('token');
 let check_login;
    if(get_token !== undefined){
      
    check_login = get_token;
    }else{
      localStorage.removeItem('token');
      localStorage.removeItem('name');
      localStorage.removeItem('loginbefore');
      localStorage.removeItem('role');
      check_login = false;
    }

  const [check_login_data,setLogin] =  useState(check_login);

  return (
    <GlobalContext.Provider  value={{ siteName, setSiteName,default_country,setDefaultCoutry,default_langage,setDefaultLangague,check_login_data,setLogin,default_country_detail,setDefaultCoutryDetails,default_langage_details,setDefaultLangagueDetails }}>
      {children}
    </GlobalContext.Provider>
  );
};
